import React from 'react';
import { message } from 'antd';
import {
  registerLoginListener,
  getUserAsync,
  setSessionStartTime,
  clearSessionStartTime,
  handleExpiredSessionAsync,
} from './cognito';

import UserContext from './contexts/user.context';
import Authenticator from './components/authenticator/Authenticator';
import { Banner, Dashboard, IdleTimer } from './components/dashboard';

function App() {
  const [isAuthenticated, setAuthenticated] = React.useState<any>(false);

  const getUserSetAuthenticatedAsync = async () => {
    const user = await getUserAsync();
    setAuthenticated(user);
  };

  // For sign in/out events
  registerLoginListener(async (data) => {
    const { payload } = data;
    if (payload.event === 'signOut') {
      setAuthenticated(false);
      clearSessionStartTime();
    } else if (payload.event === 'signIn' || payload.event === 'configured') {
      if (
        payload.event === 'configured' &&
        (await handleExpiredSessionAsync())
      ) {
        message.info('Your session has expired, please re-authenticate.');
        setAuthenticated(false);
        return;
      }
      setSessionStartTime();
      await getUserSetAuthenticatedAsync();
    }
  });

  // TODO fix inline styles, tap into Amplify customization
  return (
    <div className="App">
      {!isAuthenticated && <Banner />}
      {isAuthenticated ? (
        <UserContext.Provider
          value={{
            user: isAuthenticated,
            isAdmin:
              isAuthenticated.attributes['custom:scopes'] !== undefined &&
              isAuthenticated.attributes['custom:scopes'].includes('admin'),
            setUser: getUserSetAuthenticatedAsync,
          }}
        >
          <IdleTimer />
          <Dashboard />
        </UserContext.Provider>
      ) : (
        <Authenticator />
      )}
    </div>
  );
}

export default App;
